<template>
  <div class="print-hide">
    <div class="row full-width q-px-md">
      <span>
        Quote #<strong>{{ quoteNumber }}/{{ quoteRevisionNumber }}</strong>
      </span>
    </div>
    <SAITitle text-align="left" class="inline q-px-md q-my-sm">
      {{ title }}
    </SAITitle>
    <CarSummary
      class="q-pb-lg q-px-md"
      :modelYear="variant.modelYear"
      :make="quote.make.description"
      :model="quote.model.name"
      :variant="variant.name"
      :bodyType="quote.bodyType"
      :doors="variant.doors"
      :transmission="variant.transmission"
      :gears="variant.gears"
      :liters="variant.fuelTankCapacity"
      :imgSrc="photo"
      :variant-details="variantDetails"
      :on-road-cost="price.onRoadCost"
      :listPrice="price.listPrice"
      :sale-tag-img="saleTagImg"
      :color="quote.exteriorColour.name"
    />
    <p class="text-weight-medium text-title q-mb-sm q-px-md text-grye-10">
      Your Novated Lease Quote Summary
    </p>
    <SummaryPaySavings
      class="q-mx-md q-mb-sm"
      :net-impact-on-pay="novated.impactTakeHome"
      :lease-savings-over-term="
        (novated.taxSaving + novated.gstSavingBudget) * (leaseTerm * 12)
      "
      :residual-value="novated.residualValue"
      :lease-term="leaseTerm"
      :frequency="frequency"
      :fbt="price.fbtValue"
    />
    <QSeparator class="q-mt-lg q-mb-sm" color="grey-4" />
    <LeaseBreakdown
      :budgets="novated.budgets"
      :additional-insurances="novated.additionalInsurances"
      :fees="novated.fees"
      :total-costs="totalCosts"
      :frequency="frequency"
      :lease-term="quote.leaseTerm"
      :kms-per-year="quote.kmsPerYear"
      @update:frequency="$emit('update:frequency', $event)"
    />
    <LeaseSummary
      :gross-salary="novated.grossSalary"
      :pre-tax-deduction="novated.preTaxDeduction"
      :net-taxable-income="novated.netTaxableIncome"
      :income-tax="novated.incomeTax"
      :fbt-tax-exemption="novated.fbtTaxExemption"
      :post-tax-deduction="novated.postTaxDeduction"
      :net-income="novated.netIncome"
      :frequency="frequency"
    />
    <LeaseTotalSavings
      class="q-mx-md q-mb-md"
      :tax-saving="novated.taxSaving"
      :gst-saving-budget="novated.gstSavingBudget"
      :gst-saving-vehicle="novated.gstSavingVehicle"
      :frequency="frequency"
    />
  </div>
</template>

<script>
import isMiles from '@/utils/is-miles';
import { SAITitle } from 'ecx.saigon.ui.common';
import { QSeparator } from 'quasar';

export default {
  name: 'QuoteSummaryOrganism',
  props: {
    title: String,
    variant: {
      type: Object,
      default: () => ({}),
    },
    novated: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Object,
      default: () => ({}),
    },
    quote: {
      type: Object,
      default: () => ({
        make: {},
        model: {},
        exteriorColour: {},
      }),
    },
    variantDetails: {
      type: Array,
      default: () => [],
    },
    photo: String,
    leaseTerm: Number,
    frequency: String,
    totalCosts: Number,
    showPrintAction: Boolean,
    saleTagImg: String,
  },
  computed: {
    quoteNumber() {
      return isMiles(this.quote)
        ? this.quote.milesQuoteRef
        : this.quote.erpQuoteRef;
    },
    quoteRevisionNumber() {
      return this.quote.quoteRevisionNumber;
    },
  },
  components: {
    QSeparator,
    SAITitle,
    SummaryPaySavings: () => import('../summary-pay-savings'),
    CarSummary: () => import('../car-summary'),
    LeaseBreakdown: () => import('../lease-breakdown'),
    LeaseSummary: () => import('../../organism/lease-summary'),
    LeaseTotalSavings: () => import('../../molecule/lease-total-savings'),
  },
};
</script>
